export const API_UNKNOWN_ERROR = 'API_UNKNOWN_ERROR';
export const API_BAD_REQUEST_ERROR = 'API_BAD_REQUEST_ERROR'; // 400
export const API_UNAUTHORIZED_ERROR = 'API_UNAUTHORIZED_ERROR'; // 403 + body: {error: UNAUTHORIZED}
export const API_FORBIDDEN_ERROR = 'API_FORBIDDEN_ERROR'; // 403
export const API_NOT_FOUND_ERROR = 'API_NOT_FOUND_ERROR'; // 404
export const API_OPERATION_FAILED_ERROR = 'OPERATION_FAILED';
export const API_BAD_REQUEST_BODY_ERROR = 'BAD_REQUEST_BODY';
export const WEBMASTER_NOT_FOUND = 'WEBMASTER_NOT_FOUND';
